export const extractErrorMessage = (error: unknown) => {
  // Handling standard JavaScript Error
  if (error instanceof Error) {
    return error.message;
  }

  // Handling error objects (e.g., with 'reason' or 'message' properties)
  if (typeof error === 'object' && error !== null) {
    const errorObj = error as Record<string, unknown>;

    // Check for common properties like 'reason' or 'message'
    if (typeof errorObj.reason === 'string') {
      return errorObj.reason;
    }
    if (typeof errorObj.message === 'string') {
      return errorObj.message;
    }

    // Handling GraphQL errors with an array of error messages
    if (Array.isArray(errorObj.errors)) {
      const messages = errorObj.errors
        .filter((err) => typeof err === 'object' && err !== null)
        .map((err) => {
          const errObj = err as Record<string, unknown>;
          return typeof errObj.message === 'string' ? errObj.message : '';
        })
        .filter((msg) => msg !== ''); // Filter out empty messages

      if (messages.length > 0) {
        return messages.join(', ');
      }
    }
  }

  // Default error message
  return 'An unexpected error occurred';
};
